import { merge } from 'lodash';
import pkg from '../../package.json';

let instance$;

const appConfig = {
    aid: 103447331,
    token: 'b4a266f516524a1aba5a4630bd52d2da'
};

export function initOrUpdateApmInstanceConfig(config) {
    return runApmInstanceSafely(instance => {
        const rawConfig = instance.getConfig();
        instance.updateConfig(merge({}, rawConfig, config));
    }, config);
}

const needAggregationUrls = [
    { reg: /marketing\/.+/, mapper: () => '/marketing/:id' },
    { reg: /guide\/.+/, mapper: () => '/guide/:id' },
    { reg: /orders\/.+/, mapper: () => '/orders/:orderNo' }
];

export function runApmInstanceSafely(run, config) {
    if (!instance$ && window.NioApmPlus) {
        instance$ = window.NioApmPlus.NioApmPlus.createDefaultInstance(
            merge(
                {
                    aid: appConfig.aid,
                    token: appConfig.token,
                    release: pkg.version,
                    plugins: {
                        pageview: {
                            routeMode: 'history',
                            extractPid: url => {
                                try {
                                    const pathname = new URL(url).pathname;

                                    const decision = needAggregationUrls.find(
                                        x => x.reg.test(pathname)
                                    );

                                    if (decision) {
                                        return decision.mapper(pathname);
                                    }

                                    return pathname;
                                } catch (e) {
                                    return url;
                                }
                            }
                        },
                        blankScreen: {
                            // dom打分的根节点，支持querySelector语法。
                            // 手动配置rootSelector为打分的根节点，准确定才更高。如果只想监控某个区域是否白屏，也可以配置为指定的区域节点。
                            rootSelector: '#app',
                            // dom打分的阈值。如果计算出来的分数小于阈值，则认为可能是白屏。
                            // 该参数需针对不同应用配置合适的数值，避免白屏判断不准确。
                            threshold: 1.5,
                            // 是否自动上报当前页面的截屏图片。
                            // 截屏一定程度上涉及安全隐私，但是能够帮助判定当前页面是否真的白屏。
                            screenshot: false
                        }
                    }
                },
                config
            )
        );
    }

    return instance$.then(instance => {
        if (run && instance) {
            run(instance);
        }
    });
}



// WEBPACK FOOTER //
// ./src/util/apm.js